import { inject, Inject, Injectable } from '@angular/core';

import { Storage } from '@ionic/storage-angular';

import { EnvironmentInterface } from '../../types';
import { AuthService } from '../auth/auth.service';
import { ClientUserService } from '../users/client/client.service';
import { ProUserService } from '../users/pro/pro.service';

@Injectable({
    providedIn: 'root'
})
export class AppInitService {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    proUserService = inject(ProUserService);
    clientUserService = inject(ClientUserService);

    private storage: Storage;
    private _storage: Storage | null = null;
    private environment: EnvironmentInterface;

    constructor(
        private authService: AuthService,
        @Inject('environment') environment: EnvironmentInterface,
        @Inject('storage') storage: Storage
    ) {
        this.environment = environment;
        this.storage = storage;
    }

    async Init(type: 'client' | 'pro') {
        const s = await this.storage.create();
        this._storage = s;

        if (type === 'client') {
            this.clientUserService.initStoredTemporaryEmailFromStorage();
        }

        return new Promise<void>(resolve => {
            this._storage?.get(this.environment.tokenKey).then(data => {
                const token = data;

                if (token !== null && token !== undefined && token !== '') {
                    this.authService.saveToken(token);

                    if (type === 'client') {
                        this.clientUserService.getUserWithToken(token).subscribe({
                            next: (data: any) => {
                                if (data.success === true) {
                                    this.clientUserService.setUser(data.data || null);
                                    resolve();
                                } else {
                                    this.noUserActions();
                                    resolve();
                                }
                            },
                            error: () => {
                                this.noUserActions();
                                resolve();
                            }
                        });
                    } else if (type === 'pro') {
                        this.proUserService.getUserWithToken(token).subscribe({
                            next: (data: any) => {
                                if (data.success === true) {
                                    this.proUserService.setUser(data.data || null);
                                    resolve();
                                } else {
                                    this.noUserActions();
                                    resolve();
                                }
                            },
                            error: () => {
                                this.noUserActions();
                                resolve();
                            }
                        });
                    }
                } else {
                    resolve();
                }
            });
        });
    }

    noUserActions() {
        this.authService.clearToken();
        this.authService.setRedirectRouterUrl('/login');
    }
}
